import { render, staticRenderFns } from "./CreateGroupsPlannedSlidebar.vue?vue&type=template&id=18326652"
import script from "./CreateGroupsPlannedSlidebar.vue?vue&type=script&lang=js"
export * from "./CreateGroupsPlannedSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports